const formatNumber = (value) => {
  if (typeof value !== 'number' && isNaN(+value)) {
    return value;
  }

  const str = (+value).toFixed(2);
  return str.replace('.', ',');
};

export default formatNumber;
